<h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.HAVE_INSTALLATIONS' | i18nextEager }}</h2>
<div class="multipoint-modal-have-installations__buttons">
  <button class="secondary" (click)="closeModal(false)">{{ 'COMMONS.NO' | i18nextEager }}</button>
  <button class="primary" (click)="closeModal(true)">
    {{ 'COMMONS.YES' | i18nextEager }}
  </button>
</div>
